import { AxiosError } from 'axios'
import { CountryBlockingState } from '@/types'

// Global callback to notify the context about country blocking
let countryBlockingCallback: ((state: CountryBlockingState) => void) | null = null

export function setCountryBlockingCallback(callback: (state: CountryBlockingState) => void) {
  countryBlockingCallback = callback
}

export function clearCountryBlockingCallback() {
  countryBlockingCallback = null
}

export function detectCountryBlocking(error: AxiosError): boolean {
  // Check if the error is a 403 with the specific country blocking message
  if (
    error.response?.status === 403 &&
    typeof error.response?.data === 'object' &&
    error.response.data !== null
  ) {
    const data = error.response.data as any
    const message = data.message || data.error || ''
    
    // Check if the message matches our country blocking pattern
    if (typeof message === 'string' && message.includes('country is restricted')) {
      // Extract country information from response data first, then fallback to headers
      const userCountry = data.country ||
                          error.response.headers?.['cf-ipcountry'] || 
                          error.response.headers?.['x-user-country'] || 
                          undefined

      const blockingState: CountryBlockingState = {
        isBlocked: true,
        message: message,
        userCountry: userCountry as string | undefined,
        blockedAt: new Date()
      }

      // Notify the context about the blocking
      if (countryBlockingCallback) {
        countryBlockingCallback(blockingState)
      }

      return true
    }
  }

  return false
}

export function isCountryBlockingError(error: AxiosError): boolean {
  return error.response?.status === 403 && 
         typeof error.response?.data === 'object' &&
         error.response.data !== null &&
         ((error.response.data as any).message || '').includes('country is restricted')
}